import howitWorks from './howItWorks.css'
import strawberies from '../assets/strawberies.PNG'   
import promaganate from '../assets/promaganate.jpg' 
import pineapple from '../assets/pineapple.jpg' 
import watermelon from '../assets/watermelon.PNG'
import lady from '../assets/lady.PNG'
import fruita  from '../assets/fruita 2.jpg'
import fruitaa  from '../assets/fruita1.jpg'
import deliveryman  from '../assets/deliveryman.jpg'
import deliman  from '../assets/deliman.PNG'
import deliman2  from '../assets/deliman2.png'

import {FaShoppingBasket} from 'react-icons/fa' 
import {FaBattleNet} from 'react-icons/fa' 
import {FaConfluence} from 'react-icons/fa' 
import {FaConnectdevelop} from 'react-icons/fa' 
import {FaEdge} from 'react-icons/fa' 
import {FaGg} from 'react-icons/fa' 
import {FaBars} from 'react-icons/fa'
import {FaCartPlus} from 'react-icons/fa'
import {FaCircle} from 'react-icons/fa'
import {FaCircleNotch} from 'react-icons/fa'


{/*FaCartPlus,FaCcMastercard,FaWallet,FaShoppingCart, add love */}



function HowItWorks(){
  const featuredproducts = [
                            {name:'Promaganate', productpix:promaganate,weight:1.5+'kg',price:'$'+12},
                            {name:'Pineapple', productpix:pineapple,weight:5+'kg',price:'$'+2},
                            {name:'Watermelon', productpix:watermelon,weight:2+'kg',price:'$'+16}
                           ]
return (
    <>
    
    <div className='how-it-works__container'>
      <div className='how-it-works__bg-icon'><FaCircleNotch /></div>
    <div className='how-it-works'>
      <div className='how-it-works_L'>
        <div className='how-it-works_L__img-container'>
          <div className='how-it-works_L__img-div1'>
          <img src={lady} className='how-it-works_L__img1'/>
          </div>
          <div className='how-it-works_L__img-div1'>
          <img src={deliman2} className='how-it-works_L__img1'/>
          </div>
        </div>
        <div className='how-it-works_L__img-container2'>
        <div className='how-it-works_L__img-div2a'>
          <img src={fruita} className='how-it-works_L__img2a'/>
        </div>
        <div className='how-it-works_L__img-div2b'>
          <img src={fruitaa} className='how-it-works_L__img2b'/>
        </div>
        </div>
      </div>
      
      <div className='how-it-works_R'>
        <div className='how-it-works_R__info-wraper'>
          <div className='how-it-works_R__tittle'>How it Works</div>
          <div className='how-it-works_R__text'>Lorem ipusum Lorem ipusum Lorem ipusum Lorem ipusumLorem ipusum Lorem ipusum Lorem ipusum Lorem </div>
        </div>
            <div className='how-it-works_R__list'>
              <div className='how-it-works_R__list-icon list-icon_1'><FaShoppingBasket /></div>
              <div className='how-it-works_R__list-tittle'>Activity One</div>
              <div className='how-it-works_R__list-text'>Ipusum Lorem ipusum Lorem ipusum  </div>
            </div>
            <div className='how-it-works_R__list'>
              <div className='how-it-works_R__list-icon list-icon_2'><FaShoppingBasket /></div>
              <div className='how-it-works_R__list-tittle'>Activity Two</div>
              <div className='how-it-works_R__list-text'>Ipusum Lorem ipusum Lorem ipusum  </div>
            </div>
            <div className='how-it-works_R__list'>
              <div className='how-it-works_R__list-icon list-icon_3'><FaShoppingBasket /></div>
              <div className='how-it-works_R__list-tittle'>Activity Three</div>
              <div className='how-it-works_R__list-text'>Ipusum Lorem ipusum Lorem ipusum </div>
            </div>
            <div className='how-it-works_R__list'>
              <div className='how-it-works_R__list-icon list-icon_4'><FaShoppingBasket /></div>
              <div className='how-it-works_R__list-tittle'>Activity Four</div>
              <div className='how-it-works_R__list-text'>Ipusum Lorem ipusum Lorem ipusum </div>
            </div>
      </div>
    </div>
    </div>
    </>
)
}

export default HowItWorks;



